import React from 'react';
import PropTypes from 'prop-types';
import { Container } from './styles';

const Select = ({ error, id, label, data, value, onChange, ...props }) => {
  return (
    <Container error={error}>
      <label htmlFor={id}>{label}</label>
      <select
        onChange={onChange}
        value={value}
        data-testid="select"
        id={id}
        {...props}
      >
        {data && data.length > 0 ? (
          data.map((item) => (
            <option key={item.value} value={item.value}>
              {item.label}
            </option>
          ))
        ) : (
          <></>
        )}
      </select>
      {error && <span data-testid="validator">{error}</span>}
    </Container>
  );
};

Select.propTypes = {
  error: PropTypes.string,
  id: PropTypes.string,
  label: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func,
  data: PropTypes.arrayOf(
    PropTypes.shape({ value: PropTypes.string, label: PropTypes.string })
  ),
};

Select.defaultProps = {
  error: null,
  id: null,
  label: null,
  data: null,
  value: '',
  onChange: (event) => event,
};

export default Select;
